import React from 'react';
import { SocialMediaLinks } from './styles/EventCTA.styled';
import { SocialLinks, SocialLinkFooter } from './styles/SocialLinks.styled';
import Tiktok from '../assets/svg/tiktok-icon.svg';
import Sprites from './Sprites';

export default function EventsDetailsSocialLinks({ data, dir }) {
  const followEvent = dir === 'rtl' ? 'تابع الحدث' : 'FOLLOW EVENT';
  const doesHaveSocialLinks = [
    data.facebook,
    data.instagram,
    data.linkedIn,
    data.twitter,
    data.youtube,
    data.tiktok,
  ].some((social) => social);
  return (
    doesHaveSocialLinks && (
      <SocialMediaLinks dir={dir}>
        <SocialLinks className="event_sociallink" dir={dir}>
          <p className="black_clr">{followEvent}</p>

          {data.facebook && (
            <SocialLinkFooter
              className="social_link event_social_link"
              href={data.facebook}
              rel="noreferrer nofollow"
              target="_blank"
              dir={dir}
            >
              <span className="sr-only">Facebook</span>
              <i title="Facebook" className="facebook social_icons event_facebook" />
            </SocialLinkFooter>
          )}

          {data.linkedIn && (
            <SocialLinkFooter
              className="social_link event_social_link"
              href={data.linkedIn}
              rel="noreferrer nofollow"
              target="_blank"
              dir={dir}
            >
              <span className="sr-only">LinkedIn</span>
              <i title="LinkedIn" className="linkedin social_icons" />
            </SocialLinkFooter>
          )}

          {data.instagram && (
            <SocialLinkFooter
              className="social_link event_social_link"
              href={data.instagram}
              rel="noreferrer nofollow"
              target="_blank"
              dir={dir}
            >
              <span className="sr-only">Instagram</span>
              <i title="Instagram" className="instagram social_icons" />
            </SocialLinkFooter>
          )}

          {data.twitter && (
            <SocialLinkFooter
              className="social_link event_social_link twitter_x"
              href={data.twitter}
              rel="noreferrer nofollow"
              target="_blank"
              dir={dir}
            >
              <Sprites name="twitter-x" />
            </SocialLinkFooter>
          )}

          {data.youtube && (
            <SocialLinkFooter
              className="social_link event_social_link"
              href={data.youtube}
              rel="noreferrer nofollow"
              target="_blank"
              dir={dir}
            >
              <span className="sr-only">Youtube</span>
              <i title="YouTube" className="youtube social_icons" />
            </SocialLinkFooter>
          )}

          {data.tiktok && (
            <SocialLinkFooter
              className="social_link event_social_link"
              href={data.tiktok}
              rel="noreferrer nofollow"
              target="_blank"
              dir={dir}
            >
              <span className="sr-only">Tiktok</span>
              <Tiktok title="Tiktok" className="tiktok social_icons" />
            </SocialLinkFooter>
          )}
        </SocialLinks>
      </SocialMediaLinks>
    )
  );
}
